﻿import { FIQAssist } from "../app";
import { AuthenticationApiURL } from "../constants"
import { Utils } from "@fiqas/utils"
import { Inject, Injectable } from "@fiqas/angular-utils";

@Injectable({
    module: FIQAssist,
    selector: AuthenticationApiService.selector
})
export class AuthenticationApiService {
    public static selector = "AuthenticationApiService"
    constructor(
        @Inject('$http') private $http: angular.IHttpService,
        @Inject('AuthenticationApiURL') private AuthenticationApiURL: AuthenticationApiURL
    ) {

    }

    public Authenticate({username, password}: { username: string, password: string }): ng.IHttpPromise<AccessTokenResponse> {
        var request: AccessTokenRequest = {
            grant_type: "password",
            client_id: "Fiqassist.api",
            username: username,
            password: password
        };
        return this.requestToken(request);
    }

    public SynchronousRefreshToken(token: string): AccessTokenResponse {
        var request: AccessTokenRequest = {
            grant_type: "refresh_token",
            client_id: "Fiqassist.api",
            refresh_token: token
        };
        return this.requestSynchronousOperation(`token`, request);
    }

    public RefreshToken(token: string): ng.IHttpPromise<AccessTokenResponse> {
        var request: AccessTokenRequest = {
            grant_type: "refresh_token",
            client_id: "Fiqassist.api",
            refresh_token: token
        };
        return this.requestToken(request);
    }

    private requestToken(request: AccessTokenRequest): ng.IHttpPromise<AccessTokenResponse> {
        return this.requestOperation(`token`, request);
    }

    public changePassword(userName: string, oldPassword: string, newPassword: string, culture: string): ng.IHttpPromise<any> {
        var request = {
            userName: userName,
            oldPassword: oldPassword,
            newPassword: newPassword,
            culture: culture
        };
        return this.requestOperation('password/change', request);
    }

    public changePasswordWithToken(userName: string, password: string, resetToken: string, culture: string): ng.IHttpPromise<any> {
        var request = {
            userName: userName,
            password: password,
            resetToken: resetToken,
            culture: culture
        };
        return this.requestOperation('password/changewithtoken', request);
    }

    public resetPassword(email: string, resetLink: string, culture: string): ng.IHttpPromise<any> {
        var request = {
            email: email,
            resetLink: resetLink,
            culture: culture
        };
        return this.requestOperation('password/reset', request);
    }

    private requestOperation<D, R>(operation: string, data: D): ng.IHttpPromise<R> {
        var config: ng.IRequestConfig = {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            url: `${this.AuthenticationApiURL}/${operation}`,
            data: Utils.TransformJsonToFormData(data as any)
        };
        return this.$http<R>(config);
    }

    private requestSynchronousOperation<D>(operation: string, data: D): any {
        var request = new XMLHttpRequest();
        request.open('POST', `${this.AuthenticationApiURL}/${operation}`, false);  // `false` makes the request synchronous
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        request.send(Utils.TransformJsonToFormData(data as any));
        if (request.status === 200) {
            return JSON.parse(request.responseText);
        }
        return null;
    }

}
declare interface AccessTokenRequest {
    grant_type: string;
    client_id: string;

    scope?: string;
    code?: string;
    redirect_uri?: string;
    username?: string;
    password?: string;
    refresh_token?: string;
}

export interface AccessTokenResponse {
    access_token: string;
    token_type: string;
    expires_in: number;
    refresh_token: string;
}
